import { IsNumber, IsString, Length } from 'class-validator';

export class ItemAttributeModel {
  @IsNumber()
  public attributeId: number;

  @IsString()
  @Length(1, 255)
  public value: string;

  constructor(attributeId: number, value: string) {
    this.attributeId = attributeId;
    this.value = value;
  }
}
